import { InputGroup } from '@blueprintjs/core'
import React, { Component } from 'react'

/**
 * This is gonna be our spotlight feature - whole DB index search for both FF and Admin
 */
export class Spotlight extends Component {
  render() {
    return <InputGroup type="text" placeholder="search" leftIcon="search" />
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/spotlight/spotlight.tsx